import React, { FC, memo } from 'react'

import { Loader } from '@/components/Loader'
import { SessionStatus } from '@/constants/login'

import {
  ConnectImage,
  DoneImage,
  MobileImage,
  TvImage,
  Wrapper,
} from './styles'

const SessionStatusViewRow: FC<{ status: string }> = ({ status }) => {
  return (
    <Wrapper $isExpired={status === SessionStatus.EXPIRED}>
      <TvImage $isError={status === SessionStatus.ERROR}>
        {(status === SessionStatus.ENTERED ||
          status === SessionStatus.AUTHENTICATED) && <Loader />}
      </TvImage>
      <ConnectImage $isError={status === SessionStatus.ERROR}>
        {status === SessionStatus.COMPLETED && <DoneImage />}
      </ConnectImage>
      <MobileImage
        $isOpacity={
          status === SessionStatus.ENTERED || status === SessionStatus.ERROR
        }
      />
    </Wrapper>
  )
}

export const SessionStatusView = memo(SessionStatusViewRow)
